import Phase55Img from "@/assets/img/today/moon/phases/phase_5_5__2x.webp"
import Phase515Img from "@/assets/img/today/moon/phases/phase_5_15__2x.webp"
import Phase155Img from "@/assets/img/today/moon/phases/phase_15_5__2x.webp"
import Phase1525Img from "@/assets/img/today/moon/phases/phase_15_25__2x.webp"
import Phase2515Img from "@/assets/img/today/moon/phases/phase_25_15__2x.webp"
import Phase2535Img from "@/assets/img/today/moon/phases/phase_25_35__2x.webp"
import Phase3525Img from "@/assets/img/today/moon/phases/phase_35_25__2x.webp"
import Phase3545Img from "@/assets/img/today/moon/phases/phase_35_45__2x.webp"
import Phase4535Img from "@/assets/img/today/moon/phases/phase_45_35__2x.webp"
import Phase4555Img from "@/assets/img/today/moon/phases/phase_45_55__2x.webp"
import Phase5545Img from "@/assets/img/today/moon/phases/phase_55_45__2x.webp"
import Phase5565Img from "@/assets/img/today/moon/phases/phase_55_65__2x.webp"
import Phase6555Img from "@/assets/img/today/moon/phases/phase_65_55__2x.webp"
import Phase6575Img from "@/assets/img/today/moon/phases/phase_65_75__2x.webp"
import Phase7565Img from "@/assets/img/today/moon/phases/phase_75_65__2x.webp"
import Phase7585Img from "@/assets/img/today/moon/phases/phase_75_85__2x.webp"
import Phase8575Img from "@/assets/img/today/moon/phases/phase_85_75__2x.webp"
import Phase8595Img from "@/assets/img/today/moon/phases/phase_85_95__2x.webp"
import Phase9585Img from "@/assets/img/today/moon/phases/phase_95_85__2x.webp"
import Phase9595Img from "@/assets/img/today/moon/phases/phase_95_95__2x.webp"

const IMAGES: Record<string, string> = {
  phase_5_5: Phase55Img,
  phase_5_15: Phase515Img,
  phase_15_5: Phase155Img,
  phase_15_25: Phase1525Img,
  phase_25_15: Phase2515Img,
  phase_25_35: Phase2535Img,
  phase_35_25: Phase3525Img,
  phase_35_45: Phase3545Img,
  phase_45_35: Phase4535Img,
  phase_45_55: Phase4555Img,
  phase_55_45: Phase5545Img,
  phase_55_65: Phase5565Img,
  phase_65_55: Phase6555Img,
  phase_65_75: Phase6575Img,
  phase_75_65: Phase7565Img,
  phase_75_85: Phase7585Img,
  phase_85_75: Phase8575Img,
  phase_85_95: Phase8595Img,
  phase_95_85: Phase9585Img,
  phase_95_95: Phase9595Img,
}

export type MoonDirection = "waxing" | "waning"

const PHASE_KEY_BY_DIRECTION: Record<MoonDirection, Record<number, string>> = {
  waxing: {
    5: "phase_5_15",
    15: "phase_15_25",
    25: "phase_25_35",
    35: "phase_35_45",
    45: "phase_45_55",
    55: "phase_55_65",
    65: "phase_65_75",
    75: "phase_75_85",
    85: "phase_85_95",
    95: "phase_95_95",
  },
  waning: {
    5: "phase_5_5",
    15: "phase_15_5",
    25: "phase_25_15",
    35: "phase_35_25",
    45: "phase_45_35",
    55: "phase_55_45",
    65: "phase_65_55",
    75: "phase_75_65",
    85: "phase_85_75",
    95: "phase_95_85",
  },
}

const toPhasePercent = (illumination: number): number => {
  const safe = Number.isFinite(illumination) ? illumination : 0
  const clamped = Math.min(95, Math.max(5, Math.min(100, Math.max(0, safe))))
  return Math.round((clamped - 5) / 10) * 10 + 5
}

/** Derive waxing/waning from the phase name (defaults to waxing). */
export const moonDirection = (phaseName: string | null | undefined): MoonDirection =>
  (phaseName ?? "").toLowerCase().includes("waning") ? "waning" : "waxing"

/** Pick the moon illustration for an illumination % (0-100) + direction. */
export const getMoonImage = (illuminationPercent: number, direction: MoonDirection): string =>
  IMAGES[PHASE_KEY_BY_DIRECTION[direction][toPhasePercent(illuminationPercent)]]
